import styled from "styled-components";
import { colors } from "constants/colors";
import { styleSizes } from "constants/styleSizes";
import { BasicSectionContainer } from "screens/style";
import { sectionBackgroundStyles } from "screens/sectionBackgroundStyles";

export const CancellationPolicyScreenContainer = styled(BasicSectionContainer)`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .background {
    ${sectionBackgroundStyles}

    @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
      display: none;
    }
  }

  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 64px 0;

    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      padding: 48px 0;
    }

    @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
      box-sizing: border-box;
      padding: 32px 0;
    }

    .title {
      width: 100%;
      margin: 0 0 64px;
      color: ${colors.almostBlack};
      font-size: 48px;
      font-weight: 700;
      line-height: 58px;
      text-align: center;

      @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
        font-size: 32px;
        line-height: 48px;
        text-align: left;
        margin: 0 0 16px;
      }
    }

    .secondarySubtitle {
      width: 100%;
      margin: 48px 0 16px;
      color: ${colors.almostBlack};
      font-size: 24px;
      font-weight: 600;
      line-height: 36px;
      text-align: left;
      @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
        margin: 32px 0 32px;
      }
    }

    .secondarySubtitleSecond {
      margin: 32px 0 16px;
      @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
        margin: 32px 0 32px;
      }
    }

    p {
      width: 100%;
      margin: 0;
      color: ${colors.almostBlack};
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      text-align: left;
    }

    .introduction {
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        box-sizing: border-box;
        padding: 0 8px;
      }
    }

    ul {
      margin: 0;
      padding-inline-start: 48px;

      @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
        padding-inline-start: 40px;
      }

      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        padding-inline-start: 16px;
      }

      li {
        width: 100%;
        box-sizing: border-box;
        margin: 0;
        padding-right: 16px;
        color: ${colors.almostBlack};
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        list-style-type: circle;
        text-align: left;

        & + li {
          margin-top: 12px;
        }

        .highLight {
          font-weight: 700;
        }
      }
    }

    .ending {
      width: 100%;
      display: flex;
      flex-direction: column;
      row-gap: 16px;
      margin-top: 48px;

      @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
        margin-top: 32px;
      }

      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        margin-top: 24px;
      }

      p {
        margin: 0;
      }
    }
  }
`;
